export function Testimonials() {
  const testimonials = [
    {
      name: 'Michael Rodriguez',
      property: 'Residential Client',
      location: 'Henderson, NV',
      date: 'November 2024',
      rating: 5,
      title: 'Amazing Backyard Transformation',
      text: 'RW Construction transformed our backyard into an amazing outdoor living space. The synthetic grass and paver patio exceeded our expectations. Professional team, quality work, and great communication throughout the project.',
      avatar: 'https://public.readdy.ai/ai/img_res/9fd99713d79ea05882d4b79368760235.jpg',
      projectImage: 'https://readdy.ai/api/search-image?query=Beautiful%20completed%20backyard%20patio%20with%20synthetic%20grass%20lawn%20and%20elegant%20paver%20stone%20patio%2C%20outdoor%20furniture%2C%20desert%20landscaping%2C%20Las%20Vegas%20home%20exterior%2C%20professional%20photography%2C%20sunny%20day&width=600&height=400&seq=project-photo-001&orientation=landscape',
      verified: true
    },
    {
      name: 'Sarah Thompson',
      property: 'Pool Renovation',
      location: 'Summerlin, NV',
      date: 'October 2024',
      rating: 5,
      title: 'Pool Looks Brand New',
      text: 'Our pool was in terrible condition, but RW Construction brought it back to life with expert plaster repair. They were punctual, professional, and the results are stunning. Highly recommend their pool services!',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20happy%20female%20homeowner%2C%20woman%20smiling%20confidently%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-avatar-002&orientation=squarish',
      projectImage: 'https://readdy.ai/api/search-image?query=Stunning%20renovated%20swimming%20pool%20with%20fresh%20blue%20plaster%20finish%2C%20crystal%20clear%20water%2C%20modern%20pool%20deck%2C%20Las%20Vegas%20backyard%2C%20professional%20real%20estate%20photography%2C%20bright%20sunny%20day&width=600&height=400&seq=project-photo-002&orientation=landscape',
      verified: true
    },
    {
      name: 'David Chen',
      property: 'Commercial Property',
      location: 'Las Vegas, NV',
      date: 'September 2024',
      rating: 5,
      title: 'Professional Commercial Work',
      text: 'We hired RW Construction for our commercial property renovation. They completed the project on time and within budget. The quality of work is exceptional, and they minimized disruption to our business operations.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20satisfied%20male%20business%20owner%2C%20Asian%20man%20in%20professional%20attire%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-avatar-003&orientation=squarish',
      projectImage: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20building%20exterior%20with%20beautiful%20paver%20walkway%20and%20professional%20landscaping%2C%20business%20property%2C%20clean%20lines%2C%20Las%20Vegas%20commercial%20construction%2C%20professional%20photography&width=600&height=400&seq=project-photo-003&orientation=landscape',
      verified: true
    },
    {
      name: 'Jennifer Martinez',
      property: 'Complete Renovation',
      location: 'North Las Vegas, NV',
      date: 'August 2024',
      rating: 5,
      title: 'Exceeded All Expectations',
      text: 'The team handled our complete outdoor renovation efficiently and professionally. They explained everything clearly and the results are perfect. Great service from start to finish!',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20satisfied%20female%20client%2C%20Hispanic%20woman%20smiling%20warmly%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-avatar-004&orientation=squarish',
      projectImage: 'https://readdy.ai/api/search-image?query=Beautiful%20outdoor%20living%20space%20with%20covered%20patio%2C%20elegant%20pavers%2C%20outdoor%20kitchen%20area%2C%20desert%20landscaping%2C%20Las%20Vegas%20home%20backyard%20renovation%2C%20professional%20photography&width=600&height=400&seq=project-photo-004&orientation=landscape',
      verified: true
    },
    {
      name: 'Robert Williams',
      property: 'Landscaping Project',
      location: 'Boulder City, NV',
      date: 'July 2024',
      rating: 5,
      title: 'Outstanding Craftsmanship',
      text: 'RW Construction did an outstanding job on our landscaping and concrete work. The attention to detail and craftsmanship is evident in every aspect. Our property looks incredible!',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20happy%20male%20homeowner%2C%20senior%20man%20smiling%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-avatar-005&orientation=squarish',
      projectImage: 'https://readdy.ai/api/search-image?query=Stunning%20desert%20landscaping%20with%20decorative%20rocks%2C%20drought-tolerant%20plants%2C%20elegant%20concrete%20walkway%2C%20modern%20Las%20Vegas%20front%20yard%2C%20professional%20landscape%20photography&width=600&height=400&seq=project-photo-005&orientation=landscape',
      verified: true
    },
    {
      name: 'Amanda Foster',
      property: 'Paver Driveway',
      location: 'Paradise, NV',
      date: 'June 2024',
      rating: 5,
      title: 'Beautiful Driveway',
      text: 'Professional service from consultation to completion. The crew was respectful, cleaned up thoroughly, and our new paver driveway looks fantastic. Excellent value for the quality provided.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20satisfied%20female%20homeowner%2C%20blonde%20woman%20smiling%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-avatar-006&orientation=squarish',
      projectImage: 'https://readdy.ai/api/search-image?query=Elegant%20paver%20stone%20driveway%20leading%20to%20modern%20Las%20Vegas%20home%2C%20herringbone%20pattern%2C%20clean%20edges%2C%20professional%20installation%2C%20curb%20appeal%2C%20real%20estate%20photography&width=600&height=400&seq=project-photo-006&orientation=landscape',
      verified: true
    },
    {
      name: 'Carlos Mendez',
      property: 'Pool Deck Resurfacing',
      location: 'Spring Valley, NV',
      date: 'May 2024',
      rating: 5,
      title: 'Cool Deck Perfection',
      text: 'Incredible transformation of our pool deck! The cool deck coating they applied looks beautiful and stays comfortable even in the Vegas summer heat. Very impressed with their professionalism.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20satisfied%20Hispanic%20male%20homeowner%2C%20middle-aged%20man%20with%20friendly%20smile%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-avatar-007&orientation=squarish',
      projectImage: 'https://readdy.ai/api/search-image?query=Beautiful%20resurfaced%20pool%20deck%20with%20cool%20deck%20coating%2C%20light%20colored%20surface%20around%20swimming%20pool%2C%20outdoor%20lounge%20chairs%2C%20Las%20Vegas%20backyard%2C%20professional%20photography%20sunny%20day&width=600&height=400&seq=project-photo-007&orientation=landscape',
      verified: true
    },
    {
      name: 'Lisa Patterson',
      property: 'Artificial Turf',
      location: 'Green Valley, NV',
      date: 'April 2024',
      rating: 5,
      title: 'Perfect Synthetic Lawn',
      text: 'Best decision we made for our front yard! The synthetic grass looks so real and we no longer have to worry about watering or maintenance. RW Construction made the whole process easy.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20happy%20female%20homeowner%2C%20woman%20in%20her%20forties%20smiling%20brightly%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-avatar-008&orientation=squarish',
      projectImage: 'https://readdy.ai/api/search-image?query=Lush%20green%20synthetic%20artificial%20turf%20lawn%20in%20front%20yard%2C%20perfectly%20manicured%20edges%2C%20desert%20landscaping%20border%2C%20modern%20Las%20Vegas%20home%20exterior%2C%20professional%20photography&width=600&height=400&seq=project-photo-008&orientation=landscape',
      verified: true
    },
    {
      name: 'James Wilson',
      property: 'Complete Backyard',
      location: 'Enterprise, NV',
      date: 'March 2024',
      rating: 5,
      title: 'Resort-Style Backyard',
      text: 'From pavers to pool renovation to landscaping, RW Construction handled our entire backyard project. The coordination was seamless and the final result is like having a resort in our own home.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20satisfied%20male%20homeowner%2C%20African%20American%20man%20smiling%20confidently%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-avatar-009&orientation=squarish',
      projectImage: 'https://readdy.ai/api/search-image?query=Luxurious%20resort-style%20backyard%20with%20swimming%20pool%2C%20elegant%20paver%20patio%2C%20outdoor%20kitchen%2C%20fire%20pit%20area%2C%20palm%20trees%2C%20Las%20Vegas%20luxury%20home%20exterior%2C%20professional%20photography&width=600&height=400&seq=project-photo-009&orientation=landscape',
      verified: true
    },
    {
      name: 'Maria Santos',
      property: 'Paver Patio',
      location: 'Whitney, NV',
      date: 'February 2024',
      rating: 5,
      title: 'Gorgeous Patio Design',
      text: '¡Excelente trabajo! The paver patio they built is absolutely gorgeous. They were very patient explaining everything in Spanish and the quality exceeded what we expected. Highly recommend!',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20happy%20Hispanic%20female%20homeowner%2C%20woman%20smiling%20warmly%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-avatar-010&orientation=squarish',
      projectImage: 'https://readdy.ai/api/search-image?query=Beautiful%20paver%20stone%20patio%20with%20circular%20pattern%20design%2C%20outdoor%20dining%20set%2C%20string%20lights%2C%20cozy%20backyard%20entertaining%20space%2C%20Las%20Vegas%20home%2C%20professional%20photography&width=600&height=400&seq=project-photo-010&orientation=landscape',
      verified: true
    },
    {
      name: 'Thomas Anderson',
      property: 'Pool Plaster Repair',
      location: 'Centennial Hills, NV',
      date: 'January 2024',
      rating: 5,
      title: 'Flawless Pool Repair',
      text: 'After getting quotes from several companies, RW Construction offered the best value. Their pool plaster work is flawless and they finished ahead of schedule. Will definitely use them again.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20satisfied%20male%20homeowner%2C%20older%20gentleman%20with%20gray%20hair%20smiling%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-avatar-011&orientation=squarish',
      projectImage: 'https://readdy.ai/api/search-image?query=Pristine%20swimming%20pool%20with%20fresh%20white%20plaster%20finish%2C%20sparkling%20blue%20water%2C%20modern%20pool%20coping%2C%20Las%20Vegas%20backyard%20pool%20renovation%2C%20professional%20real%20estate%20photography&width=600&height=400&seq=project-photo-011&orientation=landscape',
      verified: true
    },
    {
      name: 'Nicole Baker',
      property: 'Outdoor Kitchen',
      location: 'Aliante, NV',
      date: 'December 2023',
      rating: 5,
      title: 'Dream Outdoor Kitchen',
      text: 'Our outdoor kitchen and entertainment area turned out amazing! RW Construction brought our vision to life with beautiful pavers and custom features. We host parties every weekend now!',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20happy%20young%20female%20homeowner%2C%20woman%20in%20her%20thirties%20smiling%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-avatar-012&orientation=squarish',
      projectImage: 'https://readdy.ai/api/search-image?query=Stunning%20outdoor%20kitchen%20with%20built-in%20grill%2C%20granite%20countertops%2C%20bar%20seating%2C%20paver%20patio%2C%20string%20lights%2C%20Las%20Vegas%20backyard%20entertaining%20space%2C%20professional%20photography%20evening&width=600&height=400&seq=project-photo-012&orientation=landscape',
      verified: true
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-orange-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
            <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">Customer Reviews</span>
          </div>
          <h2 className="text-5xl font-bold text-[#2C2C2C] mb-4">Real Results from<br />Real Customers</h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            See what Las Vegas homeowners are saying about their experience with RW Construction
          </p>
          
          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-8 mt-8">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-full">
                <i className="ri-star-fill text-[#FF6B35] text-xl"></i>
              </div>
              <div className="text-left">
                <div className="text-2xl font-bold text-[#2C2C2C]">4.9/5</div>
                <div className="text-xs text-gray-500">Average Rating</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-full">
                <i className="ri-user-heart-line text-[#FF6B35] text-xl"></i>
              </div>
              <div className="text-left">
                <div className="text-2xl font-bold text-[#2C2C2C]">500+</div>
                <div className="text-xs text-gray-500">Happy Customers</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-full">
                <i className="ri-verified-badge-fill text-[#FF6B35] text-xl"></i>
              </div>
              <div className="text-left">
                <div className="text-2xl font-bold text-[#2C2C2C]">100%</div>
                <div className="text-xs text-gray-500">Verified Reviews</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-full">
                <i className="ri-thumb-up-fill text-[#FF6B35] text-xl"></i>
              </div>
              <div className="text-left">
                <div className="text-2xl font-bold text-[#2C2C2C]">98%</div>
                <div className="text-xs text-gray-500">Would Recommend</div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
            >
              {/* Project Photo */}
              <div className="relative h-48 w-full overflow-hidden">
                <img 
                  src={testimonial.projectImage}
                  alt={`${testimonial.title} - ${testimonial.property} project by RW Construction in ${testimonial.location}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`${testimonial.property} - ${testimonial.location}`}
                />
                <div className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm px-3 py-1 rounded-full flex items-center gap-1.5">
                  <i className="ri-map-pin-2-fill text-[#FF6B35] text-sm"></i>
                  <span className="text-xs font-medium text-[#2C2C2C]">{testimonial.location}</span>
                </div>
                {testimonial.verified && (
                  <div className="absolute top-3 right-3 bg-green-500 text-white px-2.5 py-1 rounded-full flex items-center gap-1">
                    <i className="ri-verified-badge-fill text-sm"></i>
                    <span className="text-xs font-medium">Verified</span>
                  </div>
                )}
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex gap-0.5">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-[#FF6B35] text-base"></i>
                    ))}
                  </div>
                  <span className="text-xs text-gray-400">{testimonial.date}</span>
                </div>
                
                <h4 className="text-lg font-bold text-[#2C2C2C] mb-2">{testimonial.title}</h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-5 line-clamp-3">{testimonial.text}</p>
                
                <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                  <div className="relative">
                    <img 
                      src={testimonial.avatar}
                      alt={`${testimonial.name} - RW Construction client testimonial`}
                      className="w-12 h-12 rounded-full object-cover ring-2 ring-[#FF6B35]/20"
                      title={testimonial.name}
                    />
                    {testimonial.verified && (
                      <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center">
                        <i className="ri-check-line text-white text-xs"></i>
                      </div>
                    )}
                  </div>
                  <div>
                    <div className="font-bold text-[#2C2C2C] text-sm">{testimonial.name}</div>
                    <div className="text-gray-500 text-xs">{testimonial.property}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Google Rating CTA */}
        <div className="mt-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-8 text-center text-white shadow-xl max-w-4xl mx-auto">
          <div className="flex items-center justify-center gap-2 mb-4">
            <img src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" alt="Google" className="h-6" />
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#FBBC04] text-lg"></i>
              ))}
            </div>
            <span className="text-sm font-semibold text-[#2C2C2C]">4.9 Rating</span>
          </div>
          <p className="text-gray-600 text-sm mb-6">Join hundreds of satisfied Las Vegas homeowners who trust RW Construction</p>
          <a
            href="tel:7025001790"
            className="inline-flex items-center gap-3 bg-white text-orange-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-xl"></i>
            Call 702-500-1790
          </a>
        </div>
      </div>
    </section>
  );
}
